var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote-wrapper"},[_c('div',{staticClass:"quote-div"},[_c('new-quote')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }